module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal fade modal-load-request",
    attrs: {
      "tabindex": "-1",
      "role": "dialog"
    }
  }, [_c('div', {
    staticClass: "modal-dialog",
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_vm._v("\n        Request Details\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('h3', {
    staticClass: "m-b-lg"
  }, [_vm._v(_vm._s(_vm.load.commodity_and_location))]), _vm._v(" "), _c('div', {
    staticClass: "row row-clear-sm-6"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('p', {
    staticClass: "material-details"
  }, [_c('strong', [_vm._v("Loading Date")]), _c('br'), _vm._v("\n              " + _vm._s(_vm.load.loading_date) + "\n            ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('p', {
    staticClass: "material-details"
  }, [_c('strong', [_vm._v("Loading Time")]), _c('br'), _vm._v("\n              " + _vm._s(_vm.load.loading_time) + "\n            ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('p', {
    staticClass: "material-details"
  }, [_c('strong', [_vm._v("Delivery Date")]), _c('br'), _vm._v("\n              " + _vm._s(_vm.load.delivery_date) + "\n            ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('p', {
    staticClass: "material-details"
  }, [_c('strong', [_vm._v("Delivery Time")]), _c('br'), _vm._v("\n              " + _vm._s(_vm.load.delivery_time) + "\n            ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('p', {
    staticClass: "material-details lead"
  }, [_c('strong', [_vm._v("Rate")]), _c('br'), _vm._v("\n              " + _vm._s(_vm.load.rate) + "\n            ")])])]), _vm._v(" "), _c('div', {
    staticClass: "map-container"
  }, [_c('distance-map', {
    ref: "map",
    attrs: {
      "location-from": _vm.load.location_from,
      "location-to": _vm.load.location_to
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('div', {
    staticClass: "row"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6 footer-right"
  }, [_c('ladda-button', {
    ref: "decline",
    attrs: {
      "type": "danger",
      "disabled": !_vm.canEditLoadRequests,
      "size": "small",
      "on-click": _vm.handleDeclineRequest
    }
  }, [_vm._v("Decline")]), _vm._v(" "), _c('ladda-button', {
    ref: "accept",
    attrs: {
      "type": "success",
      "disabled": !_vm.canEditLoadRequests,
      "size": "small",
      "on-click": _vm.handleAcceptRequest
    }
  }, [_vm._v("Accept")])], 1)])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-6 footer-left"
  }, [_c('button', {
    staticClass: "btn btn-sm btn-default",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("Close")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../~/vue-loader/lib/template-compiler?{"id":"data-v-0539eea8"}!../~/vue-loader/lib/selector.js?type=template&index=0!./src/components/loads/LoadRequestModal.vue
// module id = 919
// module chunks = 0